module.exports = __webpack_public_path__ + "img/spacing-width-01.786b0546.svg";